import { render } from "./ASPreloader.vue?vue&type=template&id=aebfe236"
import script from "./ASPreloader.vue?vue&type=script&lang=js"
export * from "./ASPreloader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__